import '../../activityExecutors/ActivityActions.scss';
import React from 'react';
import { useForm } from 'react-hook-form';
import { ProcessExecutionService } from '@services/actions/ProcessExecutionService';
import ModalContainer, { IModalContainerProps } from '@molecules/ModalContainer/ModalContainer';
import TextareaControl from '@srm/ui/controls/TextareaControl';
import { stringifyError } from '@srm/core/errors';
import { useActionSubmit } from '@organisms/actions/useActionSubmit';
import { useUnsavedFormInput } from '@srm/ui/hooks/useUnsavedFormInput';
import { IRemoveFromControlProps } from './IRemoveFromControlProps';

interface IRemoveFromControlFormData {
    comment?: string;
}

export const RemoveFromControlModal: React.FC<IRemoveFromControlProps> = (props: IRemoveFromControlProps) => {
    const formMethods = useForm<IRemoveFromControlFormData>({ mode: 'onBlur' });
    const hasUnsavedInput = useUnsavedFormInput(formMethods, { textFields: ['comment'] });

    const { errorText, isBusy, isSubmitting, okClick, cancelClick } = useActionSubmit({
        completeHandler: props.completeHandler,
        initialBusy: false,
        resetErrorOnSubmit: true,
        mapError: stringifyError,
        submit: (form: IRemoveFromControlFormData) =>
            new ProcessExecutionService().removeFromControl(props.objId, form.comment ?? ''),
        onSuccess: (x) => {
            if (x.status == 200 && props?.completeHandler) props.completeHandler(true);
        },
    });

    const modalContainerProps: IModalContainerProps = {
        header: 'Снять с контроля',
        size: props.modalSize,
        showOkButton: true,
        showCancelButton: true,
        okButtonText: props.okButtonText,
        cancelButtonText: props.cancelButtonText,
        loading: isBusy,
        closeDisabled: isSubmitting,
        hasUnsavedInput,
        errorText: errorText,
        formMethods: formMethods,
        onSubmit: okClick,
        onCancel: cancelClick,
    };

    return (
        <ModalContainer {...modalContainerProps}>
            <TextareaControl name="comment" label="Комментарий" rows={6} control={formMethods.control} />
        </ModalContainer>
    );
};
